import React, {useContext, useEffect, useState} from 'react';
import {DispatchContext} from '../../../../store';
import {useNavigate} from 'react-router';
import {SNACKBAR_OPEN} from '../../../../reducers';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {Form, Formik} from 'formik';
import {Button, Card, Grid} from '@mui/material';
import {loansAction} from '../../../../services/LoanServices';
import FileUpload from '../../../../common/ImageUpload/FileUpload';
import LoanEntryOneUpdate from './LoanEntryOneUpdate';
import LoanEntryTwoUpdate from './LoanEntryTwoUpdate';
import LoanEntryThreeUpdate from './LoanEntryThreeUpdate';
import {useLocation} from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import {uploadAction} from '../../../../services/PhotoServices';
import PageWrapper from '../../../../common/PageWrapper/PageWrapper';

export default function LoanUpdate() {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const [loans, setLoans] = useState({});
  const loanData = loans?.catalogue;
  const [loanImgIds, setLoanImgIds] = useState([]);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get('id');
  const code = 'en';
  const initialValues = {
    ...loans,
    ...loanData
  };

  useEffect(() => {
    getLoanUpdateData();
  }, []);

  const getLoanUpdateData = () => {
    loansAction('get', id).then(res => {
      setLoans({
        ...res?.data,
        condition: res?.data?.translations?.en?.condition || '',
        purpose: res?.data?.translations?.en?.purpose || '',
        agency_loaned_to: res?.data?.translations?.en?.agency_loaned_to || '',
      });
    })
  }

  const getStringValue = (value) => {
    if (!value) return '';
    if (typeof value === 'object') {
      return value?.name || value?.code || '';
    }
    return value;
  };

  const onSubmit = (values) => {
    const combinedAttachments = (loans?.attachments || []).concat(loanImgIds || []);

    const uniqueIdsSet = new Set();

    combinedAttachments.forEach(id => {
      const parsedId = parseInt(id);
      const parsedIdFromObj = parseInt(id?.id);

      if (!isNaN(parsedId)) {
        uniqueIdsSet.add(parsedId);
      }

      if (!isNaN(parsedIdFromObj)) {
        uniqueIdsSet.add(parsedIdFromObj);
      }
    });

    const newAttachmentIds = Array.from(uniqueIdsSet);

    const loanValues = {
      museum_id: values?.museum_id,
      accession_no: getStringValue(values?.accession_no),
      catalogue_id: values?.id,
      duration: values?.duration,
      duration_unit: values?.duration_unit,
      issue_date: values?.issue_date,
      return_date: values?.return_date,
      attachment_ids: newAttachmentIds,
      translations: {
        en: {
          condition: getStringValue(values?.condition),
          purpose: getStringValue(values?.purpose),
          agency_loaned_to: getStringValue(values?.agency_loaned_to)
        }
      }
    }

    loansAction('put', id, {...loanValues}).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Request resubmitted successful'}
      });
      navigate(`/management/artifact-managements`)
    })
  }

  const handleDetete = (id) => {
    uploadAction('delete', id).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'PDF removed successful'}
      });
      getLoanUpdateData();
    })
  }

  return (
    <PageWrapper>
      <Box sx={{display: {sm: 'flex', xs: 'column'}, alignItems: 'center', mt: 7, mb: 2}}>
        <Typography className={'text-500 font30'} sx={{color: '#757575'}}>Loan Request</Typography>
      </Box>
      <Box className={'header-divider'}/>
      <Formik initialValues={initialValues}
              onSubmit={onSubmit}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            <Box sx={{mb: {sm: 4, xs: 2}}}>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <LoanEntryOneUpdate code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <LoanEntryTwoUpdate code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <LoanEntryThreeUpdate code={code}/>
                </Grid>
              </Grid>
              <Box className={'dotted-divider'}/>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <Card className={'box-shadow'} sx={{p: 4}}>
                    <Typography>Uploaded Files</Typography>
                    {loans?.attachments?.map((val, index) => (
                      <Box className={'space-between'} sx={{alignItems: 'center'}}>
                        <a href={val?.file} target={'_blank'}>
                          {index + 1}) &nbsp; Loan form {index + 1}
                        </a>
                        <IconButton onClick={() => handleDetete(val?.id)}>
                          <CloseRoundedIcon sx={{color: 'red'}}/>
                        </IconButton>
                      </Box>
                    ))}
                  </Card>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Card className={'box-shadow'} sx={{p: 4}}>
                    <FileUpload setImageId={setLoanImgIds}/>
                  </Card>
                </Grid>
              </Grid>
              <Box>
                <Grid container spacing={2}>
                  <Grid item sm={9} xs={12}/>
                  <Grid item sm={3} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item sm={6} xs={12}>
                        <Button onClick={() => navigate(-1)} variant={'outlined'} color={'error'}
                                fullWidth>Cancel</Button>
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <Button variant={'contained'} type={'submit'} fullWidth>Update</Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </PageWrapper>
  );
}